var _title, _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgQuickbooks = function SvgQuickbooks(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 32,
    viewBox: "0 0 35 32",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "logo-quickbooks2")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.462 16.12c0 5.155 4.179 9.333 9.333 9.333h1.333v-3.467h-1.333c-3.235 0-5.867-2.632-5.867-5.867s2.632-5.867 5.867-5.867h3.204c0 0 0 17.79 0 18.133 0 1.915 1.552 3.467 3.467 3.467v-25.067c0 0-3.588 0-6.671 0-5.155 0-9.333 4.179-9.333 9.333zM25.8 6.788h-1.333v3.467h1.333c3.235 0 5.867 2.632 5.867 5.867s-2.632 5.867-5.867 5.867h-3.204c0 0 0-17.79 0-18.133 0-1.915-1.552-3.467-3.467-3.467v25.067c0 0 3.588 0 6.671 0 5.155 0 9.333-4.179 9.333-9.333s-4.179-9.333-9.333-9.333z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuickbooks, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/quickbooks.6ed60c94.svg";
export { ForwardRef as ReactComponent };